import { authedFetch } from '@/providers/loginWithEmail/dataProvider';

export type EmailAssetUploadResult = {
    asset_id: string;
    url: string;
};

function parseUploadError(data: unknown, fallback: string): string {
    if (!data || typeof data !== 'object') return fallback;
    const obj = data as Record<string, unknown>;
    const errors = obj.errors;
    if (errors && typeof errors === 'object') {
        const root = (errors as Record<string, unknown>).root;
        if (typeof root === 'string') return root;
        if (root && typeof root === 'object' && root !== null && 'serverError' in root) {
            return String((root as { serverError: unknown }).serverError);
        }
    }
    const detail = obj.detail;
    if (typeof detail === 'string') return detail;
    if (detail && typeof detail === 'object') {
        const root = (detail as Record<string, unknown>).root;
        if (typeof root === 'string') return root;
        if (root && typeof root === 'object' && root !== null && 'serverError' in root) {
            return String((root as { serverError: unknown }).serverError);
        }
    }
    return fallback;
}

export async function uploadEmailAsset(file: File): Promise<string> {
    const formData = new FormData();
    formData.append('file', file);

    const res = await authedFetch('/email-assets/upload', {
        method: 'POST',
        body: formData,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        throw new Error(parseUploadError(data, 'Failed to upload image'));
    }
    return (data as EmailAssetUploadResult).url;
}
